import { initReactI18next } from 'react-i18next';
import * as i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import { Config } from '@sternum/web/config';

import { namespaces } from './namespaces';

const DEFAULT_LANGUAGE = 'en';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

if (Config.mode !== 'test') {
  i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .init({
      backend: {
        loadPath: () => {
          return Config.mode === 'development'
            ? `/locales/{{lng}}/{{ns}}.json`
            : `/locales/{{lng}}/{{ns}}-${Config.localesFolderHash}.json`;
        },
      },
      fallbackLng: DEFAULT_LANGUAGE,
      ns: Object.values(namespaces),
      fallbackNS: 'common',
      defaultNS: 'common',
      returnNull: false,
      load: 'languageOnly',
      interpolation: { escapeValue: false },
      debug: false,
      saveMissing: true,
      missingInterpolationHandler: (text, value) => {
        console.warn(`Missing interpolation text`, { text, value });
      },
      missingKeyHandler: (lng, ns, key) => {
        console.warn('Missing i18n key', { lng, ns, key });
      },
    });
} else {
  /**
   * Code for importing all translation files, commented it out in case we need it
   */
  // // eslint-disable-next-line @typescript-eslint/no-var-requires
  // const fs = require('fs/promises');

  // // eslint-disable-next-line no-inner-declarations
  // async function getNamespaceFiles(path: string) {
  //   const translations: Record<string, Record<string, string>> = {};
  //   const dir = await fs.opendir(path);

  //   for await (const dirent of dir) {
  //     const fileName = dirent.name.substr(0, dirent.name.lastIndexOf('.'));
  //     translations[fileName] = require(`../../../${path}/${dirent.name}`);
  //   }

  //   return translations;
  // }

  i18n.use(initReactI18next).init({
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    ns: Object.values(namespaces),
    defaultNS: 'common',
    returnNull: false,
    interpolation: { escapeValue: false },
    resources: {
      // en: await getNamespaceFiles('./public/locales/en'),
      en: {
        validation: require('../../../public/locales/en/validation.json'),
        common: require('../../../public/locales/en/common.json'),
        auth: require('../../../public/locales/en/auth.json'),
      },
    },
  });
}

export default i18n;
export { i18n, namespaces };
